import { render, staticRenderFns } from "./integralGoodsReturn.vue?vue&type=template&id=2c44d1bf&scoped=true"
import script from "./integralGoodsReturn.vue?vue&type=script&lang=js"
export * from "./integralGoodsReturn.vue?vue&type=script&lang=js"
import style0 from "./integralGoodsReturn.vue?vue&type=style&index=0&id=2c44d1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44d1bf",
  null
  
)

export default component.exports